var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"update-button"},[_c('i',{staticClass:"el-icon-refresh-right",on:{"click":function($event){return _vm.update()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }